module.exports = "<div class=punchesContainer></div>\n\n\n\n";